export const GOOGLE_MAPS_CONFIG = {
  key: 'AIzaSyB44A5HlblNlBM2AF8kmoiorYTspftn5xQ',
  v: 'weekly'
};

export const GOOGLE_MAPS_MAP_ID = 'validatedAddressLocation';
